import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TollGridViewItem } from '@classes/toll-grid-view-item';
import { ErrorMessageComponent } from '@components/error-message/error-message.component';
import { ErrorMessageData } from '@classes/error-message-data';
import { TollService } from 'app/core/services/toll.service';
import { UiService } from 'app/core/services/ui.service';
import { TollComponent } from 'app/modules/toll/pages/toll/toll.component';
import * as _moment from 'moment';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatExpansionPanel } from '@angular/material/expansion';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { SelectionModel } from '@angular/cdk/collections';
import { ArrayToExcel } from 'app/core/services/export-table.service';


const moment = _moment;
@Component({
  selector: 'app-toll-grid',
  templateUrl: './toll-grid.component.html',
  styleUrls: ['./toll-grid.component.scss']
})
export class TollGridComponent implements OnInit {

  dataSource = new MatTableDataSource<TollGridViewItem>();
  selection = new SelectionModel<TollGridViewItem>(true, []);
  pageSizeOptions = [25, 50, 100];
  selectedRowID: string;
  displayedColumns: string[] = [
    'select',
    'siteName',
    'companyName',
    'date',
    'isTruck',
    'plate',
    'isExceptionalConvoy',
    'quantity',
    'material',
    'creationDate',
    'error',
    'action',
  ];

  tollGridFilterForm: FormGroup;
  filterLabel = "";

  @ViewChild(MatSort, { static: true }) sort: MatSort;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild("tollFilterExpansionPanel", { static: true }) expansionPanel: MatExpansionPanel;


  constructor(
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public tollService: TollService,
    public uiService: UiService,
    private route: ActivatedRoute,
    private router: Router,
    private location: Location
  ) { }

  ngOnInit() {
    this.dataSource.sortingDataAccessor = (element: any, property: any) => {
      switch (property) {
        case 'isTruck': return (element.isTruck);
        case 'error': return (element.isError);
        default: return element[property];
      }
    };
    this.initFilterForm();
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
    this.dataSource.filterPredicate = this.createFilter();
    this.getUrlParam();
    // this.getTools();
    this.onFilter();
  }

  getUrlParam() {
    if (this.route.snapshot.queryParams.selectedTab == null || parseInt(this.route.snapshot.queryParams.selectedTab) == 1) {
      const value = this.route.snapshot.queryParams;
      let param: any = {};
      if (value.companyId != null) {
        param.companyId = value.companyId;
        param.companyName = value.companyName;
      }
      if (value.siteId != null) {
        param.siteId = value.siteId;
        param.siteName = value.siteName;
      }
      if (value.start != null) {
        if (moment(value.start, "DD/MM/YYYY").isValid()) {
          param.start = moment(value.start, "DD/MM/YYYY");
        }
      }
      else {
        param.start = moment().add(-1, 'months')
      }
      if (value.end != null) {
        if (moment(value.end, "DD/MM/YYYY").isValid()) {
          param.end = moment(value.end, "DD/MM/YYYY");
        }
      }
      else {
        param.end = moment().add(1, 'months')
      }
      if (value.materialId != null) {
        param.materialId = value.materialId;
        param.materialName = value.materialName;
      }
      if (value.isTruck != null) {
        param.isTruck = value.isTruck;
      }
      if (value.billed != null) {
        param.billed = value.billed;
      }
      if (value.isError != null) {
        param.isError = value.isError;
      }
      if (value.isExceptionalConvoy != null) {
        param.isExceptionalConvoy = value.isExceptionalConvoy;
      }
      if (value.isLoading != null) {
        param.isLoading = value.isLoading;
      }
      this.initFilterForm(param);
      //this.tabGroup.selectedIndex = parseInt(this.route.snapshot.queryParams.selectedTab);
    } else {
      this.initFilterForm();
    }
  }

  exportExcel() {
    ArrayToExcel.exportArrayToExcel(this.selection.selected.filter(f => this.dataSource.filteredData.map(m => m.id).includes(f.id)).map(m => {
      return {
        Site: m.siteName,
        Société: m.companyName,
        Date: moment(m.date).format("DD/MM/YYYY"),
        Type: m.isTruck ? 'Camion' : 'Wagon',
        NumeroPlaque: m.plate,
        Convoi_exceptionnel: m.isExceptionalConvoy ? 'Oui' : 'Non',
        Quantité: m.quantity,
        Matériau: m.material,
        Encodage: moment(m.creationDate).format("DD/MM/YYYY HH:mm")
      }
    }), 'Historique_Terrestre')
  }

  private initFilterForm(filter?: any) {
    const fb = this.formBuilder;
    this.tollGridFilterForm = fb.group({
      site: fb.control((filter && filter.siteId != null) ? { id: filter.siteId, name: filter.siteName } : null),
      company: fb.control((filter && filter.companyId != null) ? { id: filter.companyId, name: filter.companyName } : null),
      isExceptionalConvoy: fb.control((filter && filter.isExceptionalConvoy != null) ? filter.isExceptionalConvoy : ""),
      isTruck: fb.control((filter && filter.isTruck != null) ? filter.isTruck : ""),
      billed: fb.control((filter && filter.billed != null) ? filter.billed : ""),
      material: fb.control((filter && filter.materialId != null) ? { id: filter.materialId, name: filter.materialName } : null),
      range: fb.group({
        start: fb.control((filter && filter.start != null) ? filter.start : null),
        end: fb.control((filter && filter.end != null) ? filter.end : null)
      }),
      isError: fb.control((filter && filter.isError != null) ? filter.isError : ""),
    });
  }

  private setFilterFormUrl() {
    if (this.route.snapshot.queryParams.selectedTab == null || parseInt(this.route.snapshot.queryParams.selectedTab) == 1) {

      const value = this.tollGridFilterForm.value;
      const formatUrlParam = (value: any): object => {
        let param: any = {};
        param.selectedTab = this.route.snapshot.queryParams.selectedTab || 1;
        if (value.company != null) {
          param.companyId = value.company.id;
          param.companyName = value.company.name;
        }
        if (value.site != null) {
          param.siteId = value.site.id;
          param.siteName = value.site.name;
        }
        if (value.range != null && value.range.start != null) {
          param.start = value.range.start.format('DD/MM/YYYY');
        }
        else {
          param.start = "null";
        }
        if (value.range != null && value.range.end != null) {
          param.end = value.range.end.format('DD/MM/YYYY');
        }
        else {
          param.end = "null";
        }
        if (value.material != null) {
          param.materialId = value.material.id;
          param.materialName = value.material.name;
        }
        if (value.billed != "") {
          param.billed = value.billed;
        }
        if (value.isError != "") {
          param.isError = value.isError;
        }
        if (value.isExceptionalConvoy != "") {
          param.isExceptionalConvoy = value.isExceptionalConvoy;
        }
        if (value.isTruck != "") {
          param.isLoading = value.isTruck;
        }
        return param;
      }

      const queryParams = formatUrlParam(value);
      const url = this.router.createUrlTree(
        [],
        {
          relativeTo: this.route,
          queryParams
        }
      ).toString();
      this.location.go(url);
      this.route.snapshot.queryParams = queryParams;
    }
  }



  getTools() {
    this.uiService.addRouteLoading();
    const filterValue = this.tollGridFilterForm.value;
    this.tollService.getTolls(filterValue.range.start, filterValue.range.end).subscribe(data => {
      this.selection.clear();
      this.dataSource.data = data.map(m => new TollGridViewItem({
        id: m.id,
        siteName: m.site?.name,
        siteId: m.site?.id,
        companyName: m.company?.name,
        date: moment(m.date).toDate(),
        companyId: m.company?.id,
        isTruck: m.isTruck,
        plate: m.plate,
        isExceptionalConvoy: m.isExceptionalConvoy,
        quantity: m.quantity,
        material: m.material?.name,
        materialId: m.material?.id,
        creationDate: moment(m.creationDate).toDate(),
        toll: m,
        isError: m.isError,
        billed: m.billed
      }));
      this.selection.select(...this.dataSource.filteredData);
      this.uiService.removeRouteLoading();
    }, error => {
      this.uiService.removeRouteLoading();
      console.error(error);
    });

  }

  selectItemClick(item: TollGridViewItem) {
    this.selectedRowID = item.id || '';
  }

  onEdit(item: TollGridViewItem) {
    const data = item.toll;
    const dialogRef = this.dialog.open(TollComponent, {
      data,
      hasBackdrop: true,
      autoFocus: false
    });

    dialogRef.afterClosed().subscribe(refresh => {
      if (refresh) {
        this.getTools();
      }
    })
  }

  onReportAnError(item: TollGridViewItem) {
    const data = new ErrorMessageData({
      tollID: item.id,
      isInError: item.isError,
      isReport: true
    });
    const dialogRef = this.dialog.open(ErrorMessageComponent, {
      data,
      hasBackdrop: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        this.getTools();
      }
    })
  }

  onErrorClick(item: TollGridViewItem) {
    const data = new ErrorMessageData({
      tollID: item.id,
      isInError: item.isError,
    });
    const dialogRef = this.dialog.open(ErrorMessageComponent, {
      data,
      hasBackdrop: true,
      autoFocus: false
    });
    dialogRef.afterClosed().subscribe(value => {
      if (value) {
        this.getTools();
      }
    })
  }

  onFilter() {
    this.dataSource.filter = JSON.stringify(this.tollGridFilterForm.value);
    this.initFilterLabel();
    this.setFilterFormUrl();
    this.expansionPanel.close();
    this.getTools();
  }
  onClearFilter() {
    this.initFilterForm();
    this.initFilterLabel();
    this.onFilter();
    this.setFilterFormUrl();
    this.getTools();
  }
  createFilter(): (data: TollGridViewItem, filter: string) => boolean {
    let filterFunction = function (data: TollGridViewItem,
      filter: string
    ): boolean {
      let searchTerms = JSON.parse(filter);
      const filterValue =
        ((typeof searchTerms.site == "object" && searchTerms.site) ? data.siteId == searchTerms.site.id : true)
        && ((typeof searchTerms.company == "object" && searchTerms.company) ? data.companyId == searchTerms.company.id : true)
        && (searchTerms.isTruck != "" ? data.isTruck == (searchTerms.isTruck == "true") : true)
        && (searchTerms.isError != "" ? data.isError == (searchTerms.isError == "true") : true)
        && (searchTerms.isExceptionalConvoy != "" ? data.isExceptionalConvoy == (searchTerms.isExceptionalConvoy == "true") : true)
        && (searchTerms.billed != "" ? data.billed == (searchTerms.billed == "true") : true)
        && ((searchTerms.range != null && searchTerms.range.start != null) ? moment(data.date).isSameOrAfter(moment(searchTerms.range.start)) : true)
        && ((searchTerms.range != null && searchTerms.range.end != null) ? moment(data.date).isSameOrBefore(moment(searchTerms.range.end)) : true)
        && ((typeof searchTerms.material == "object" && searchTerms.material) ? data.materialId == searchTerms.material.id : true)
        ;
      return filterValue;
    }
    return filterFunction;
  }
  initFilterLabel() {
    this.filterLabel = "";
    const addSeparator = () => {
      if (this.filterLabel.length > 0) {
        this.filterLabel += " | "
      }
    }
    const filterValue = this.tollGridFilterForm.value;

    if (typeof filterValue.site == "object" && filterValue.site) {
      addSeparator();
      this.filterLabel += ("Site : " + filterValue.site.name)
    }
    if (typeof filterValue.company == "object" && filterValue.company) {
      addSeparator();
      this.filterLabel += ("Société : " + filterValue.company.name)
    }
    if (filterValue.range != null && filterValue.range.start != null) {
      addSeparator();
      this.filterLabel += ("Du : " + (filterValue.range.start.format('DD/MM/YYYY')));
    }
    if (filterValue.range != null && filterValue.range.end != null) {
      addSeparator();
      this.filterLabel += ("Au : " + (filterValue.range.end.format('DD/MM/YYYY')));
    }

    if (filterValue.isExceptionalConvoy != "") {
      addSeparator();
      this.filterLabel += ("Convoi exceptionnel : " + (filterValue.isExceptionalConvoy == "true" ? "Oui" : "Non"))
    }
    if (filterValue.isTruck != "") {
      addSeparator();
      this.filterLabel += ("Type : " + (filterValue.isTruck == "true" ? "Camion" : "Wagon"))
    }
    if (typeof filterValue.material == "object" && filterValue.material) {
      addSeparator();
      this.filterLabel += ("Matériau : " + filterValue.material.name)
    }
    if (filterValue.billed != "") {
      addSeparator();
      this.filterLabel += ("Facturé : " + (filterValue.billed == "true" ? "Oui" : "Non"))
    }
    if (filterValue.isError != "") {
      addSeparator();
      this.filterLabel += ("En erreur : " + (filterValue.isError == "true" ? "Oui" : "Non"))
    }
  }

  isAllSelected() {
    const numSelected = this.selection.selected.length;
    const numRows = this.dataSource.filteredData.length;
    return numSelected === numRows;
  }

  /** Selects all rows if they are not all selected; otherwise clear selection. */
  masterToggle() {
    if (this.isAllSelected()) {
      this.selection.clear();
      return;
    }

    this.selection.select(...this.dataSource.filteredData);
  }
}
